/**
 * @author Nagarjuna Naidu <nagarjuna.naidu@siera.ai>
 *  SIERA DASHBOARD PAGE ASSET MANAGMENT UTILITY FOR DATA FILTERING
 */

// 1. ADD asset to the existing asset list
export const addAssetToList = (asset, assetToAdd) => {
  return [...asset, { ...assetToAdd }];
};
